import gql from 'graphql-tag'
import { companyFragment } from '@/graphql/company/companyFragments'
import { siteSubscriptionFragment } from '@/graphql/siteSubscription/siteSubscriptionFragments'

export const SITESUBSCRIPTION = gql`
    query siteSubscription {
        siteSubscription{
            ...siteSubscriptionFragment
            company{
                ...companyFragment
            }
        }
    }
    ${ siteSubscriptionFragment }
    ${ companyFragment }
`